import React, {useCallback} from 'react';
import {useHeaderDrawerDispatch, useHeaderDrawerState} from './header-drawer.context';
import {IoMdClose} from 'react-icons/io';
import LogoImg from 'assets/images/logo.png';
import clsx from "clsx";
import {navigate} from "@reach/router";
import {LogoutIcon, MenuIcon, MyReportIcon, QuestionIcon, UserIcon} from "components/style-guide/icons";
import {AppRouters} from "settings/index";
import {Drawer} from "components/style-guide/drawer";

import styles from './mobile-drawer.module.scss';

const NotAuthenticatedActions = React.memo(({onToggle, checkNewReportStatus}) => {
    return (
        <>
            <li className="nav-item" onClick={onToggle}>
                <span className="nav-link w-full d-flex btn-clear align-items-center gap-1" onClick={() => checkNewReportStatus(AppRouters.questions)}>
                    <QuestionIcon/> <span>Preguntas Frecuentes</span>
                </span>
            </li>
            <li className="nav-item" onClick={onToggle}>
                <span className="nav-link w-full d-flex btn-clear  align-items-center gap-1" onClick={() => checkNewReportStatus(AppRouters.signIn)}>
                    <UserIcon/> <span>Iniciar Sesión</span>
                </span>
            </li>
        </>
    )
});

export const MobileDrawer = ({isAuthenticated, userInfo, onSignOut, useInsideScroll, className, checkNewReportStatus}) => {
    const dispatch = useHeaderDrawerDispatch();
    const {isOpen} = useHeaderDrawerState();

    const toggleFn = useCallback(() => {
        dispatch({type: 'TOGGLE'});
    }, []);

    const signOut = useCallback(() => {
        onSignOut?.();
        toggleFn();
    }, []);

    return (
        <Drawer
            width="320px"
            drawerHandler={
                <div className={styles.handler}>
                    <MenuIcon/>
                </div>
            }
            open={isOpen}
            toggleHandler={toggleFn}
            closeButton={<IoMdClose size="24px" color="#000000"/>}
            drawerClassName={styles.drawer}
            closeButtonContainerClassName={styles.closeButton}>
            <div className={styles.content}>
                <img src={LogoImg} alt="logo" onClick={() => navigate(AppRouters.home, {replace: true})}/>
                {
                    isAuthenticated &&
                    <>
                        <div className="pt-4 text-center flex flex-col flex-d-center">
                            <p>{userInfo?.fullName}</p>
                            <p>{userInfo?.profile?.rut || '-'}</p>
                        </div>
                        <ul className={styles.menuContainer}>
                            <li onClick={() => checkNewReportStatus(AppRouters.questions)}>
                                <QuestionIcon/> <span>Preguntas Frecuentes</span>
                            </li>
                            <li onClick={() => checkNewReportStatus(AppRouters.myReports)}>
                                <MyReportIcon/> <span>Mis Reportes</span>
                            </li>
                            <li onClick={() => checkNewReportStatus(AppRouters.profile)}>
                                <UserIcon/> <span>Mi Perfil</span>
                            </li>
                            <li onClick={signOut}>
                                <LogoutIcon/> <span>Cerrar Sesión</span>
                            </li>
                        </ul>
                    </>
                }

                {
                    !isAuthenticated &&
                    <ul className={clsx(styles.menuContainer, styles.signOut)}>
                        <NotAuthenticatedActions onToggle={toggleFn} checkNewReportStatus={checkNewReportStatus}/>
                    </ul>
                }
            </div>
        </Drawer>
    );
};

export default MobileDrawer;
